import { httpClient } from '@/services/http/httpClient'

import type {
  FinancialDetails,
  FinancialImpactTypeCreation,
} from '@/tabs/shared/financialImpact/types'

type CreateFinancialImpactProps = {
  projectId: string
} & Omit<FinancialImpactTypeCreation, 'ideaId'>

export const createFinancialImpact = async (
  finance: CreateFinancialImpactProps,
) => {
  const { data } = await httpClient.post<FinancialDetails>(
    `/projects/financial-details/create`,
    finance,
  )
  return data
}
